import Vue from 'vue';
Vue.directive('focus', {
    inserted(el) {
        console.info('focus on', el);
        el.focus();
    }
});
//# sourceMappingURL=v-focus.js.map